import { InjectionToken } from '@angular/core';
import { OfflineFeatureToggleStore } from '@lib/feature-toggle/models';

/**
 * The device's copy of the tenant's last good feature-toggle list, supplied by the Pathfinder app shell.
 *
 * Read through `Injector.get(OFFLINE_FEATURE_TOGGLE_STORE, null)` when needed rather than injected into a field,
 * for the same bootstrap-order reason as `OFFLINE_SESSION_CONTEXT_STORE`. See `OfflineFeatureToggleStore`.
 */
export const OFFLINE_FEATURE_TOGGLE_STORE = new InjectionToken<OfflineFeatureToggleStore>('OFFLINE_FEATURE_TOGGLE_STORE');
